import styled from 'styled-components';

export const inactive=styled.div`
    opacity: 0.5;
    div , a{
      pointer-events: none;
    }
`;

